'use strict';

var useTable = require('./hooks/useTable.js');
var Cell = require('./src/Cell.js');
var ExpandColumn = require('./src/ExpandColumn.js');
var Filter = require('./src/Filter.js');
var GlobalSearch = require('./src/GlobalSearch.js');
var Head = require('./src/Head.js');
var NotFound = require('./src/NotFound.js');
var Pagination = require('./src/Pagination.js');
var Row = require('./src/Row.js');
var Sorter = require('./src/Sorter.js');
var SubRow = require('./src/SubRow.js');
var Table = require('./src/Table.js');
var TableView$1 = require('./src/TableView.js');
var Thead = require('./src/Thead.js');

const TableView = TableView$1.TableView;
TableView.GlobalSearch = GlobalSearch.GlobalSearch;
TableView.Pagination = Pagination.Pagination;
TableView.NotFound = NotFound.NotFound;
TableView.Thead = Thead.Thead;
TableView.Head = Head.Head;
TableView.Row = Row.Row;
TableView.SubRow = SubRow.SubRow;
TableView.Cell = Cell.Cell;
TableView.ExpandColumn = ExpandColumn.ExpandColumn;

exports.useTable = useTable.useTable;
exports.Filter = Filter.Filter;
exports.Sorter = Sorter.Sorter;
exports.Table = Table.Table;
exports.TableView = TableView;
//# sourceMappingURL=index.js.map
